import Vue from 'vue';
import { http } from '../../axios';
import { forceFileDownload } from '../../helpers/download';

export default {
  namespaced: true,
  actions: {
    async downloadResume(_, { sent_resume_id, filename }) {
      try {
        const { data } = await http({
          method: 'GET',
          url: '/api/new-resume/download-pdf',
          responseType: 'blob',
          params: { sent_resume_id },
        });
        forceFileDownload({ data }, filename, 'pdf', 'application/pdf');
      } catch {
        Vue.prototype.$vModal.open('warning', {
          title: 'Something went wrong',
          message: 'Failed to download resume',
        });
      }
    },
  },
};
